export function pascal(value: string | number | null | undefined): string {
  return String(value ?? '')
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}

export function oid(prefix: string, ...parts: (string | number | null | undefined)[]): string {
  return `${prefix}${parts.map(pascal).join('')}`;
}
